module.exports = __webpack_public_path__ + "img/图层 227.62322c52.png";